import axios from 'axios'

const BaseService = class {
    constructor (resource) {
        this.resource = 'api/v1' + resource
    }

    all ({ query = '' }) {
        const q = query.length > 0 ? `?${query}` : ''

        return axios.get(`${this.resource}${q}`)
    }

    search ({ query = '' }) {
        const q = query.length > 0 ? `?${query}` : ''

        return axios.get(`${this.resource}-search${q}`)
    }

    show ({ id, query = '' }) {
        const q = query.length > 0 ? `?${query}` : ''

        return axios.get(`${this.resource}/${id}${q}`)
    }

    store ({ payload }) {
        return axios.post(`${this.resource}`, payload)
    }

    update ({ id, payload }) {
        return axios.put(`${this.resource}/${id}`, payload)
    }

    destroy ({ id }) {
        return axios.delete(`${this.resource}/${id}`)
    }
}

export default BaseService
